import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="faq" className="max-w-3xl" data-id="element-44" data-mp="1cf041c63r6ni">
      <h2 className="mb-10 text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-45" data-mp="1cgb8le7dgifo">
        Frequently asked questions
      </h2>
      <div className="divide-y divide-stone-200 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-46" data-mp="252m8snr2ghby">
        {faqs.map((faq, index) => <div key={faq.q} data-id="element-47" data-mp="2065lfvroy6zx" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-stone-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-400" data-id="element-48" data-mp="1v5839j6olcyf">
              <span className="pr-8 text-sm font-semibold text-emerald-900 md:text-base" data-id="element-49" data-mp="1pls2y6a4rnfh">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-stone-500 transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" data-mp="1aoix67k2yh48" />
            </button>
            <AnimatePresence initial={false} data-id="element-51" data-mp="11vnzq00utpp0">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-52" data-mp="16oqsw71pyx4o">
                  <p className="px-6 pb-5 text-sm leading-relaxed text-stone-700 md:text-base" data-id="element-53" data-mp="j0half3psria">{faq.a}</p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}